function debounce(fn, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
}
function extractWidgetId(url) {
  if (typeof url !== 'string') return null;
  const match = url.match(/\/files\/([^_]+?-\d+)(?:_|\.|\?|$)/);
  return match ? match[1] : null;
}

const handleSrcChange = debounce((img) => {
  const widgets = document.querySelectorAll('.vw-product-widget');
  if (widgets.length > 0) {
    widgets.forEach(widget => widget.remove());
  } 

  const btns = document.querySelectorAll('#cloneVwBtn');
  if (btns.length > 0) btns.forEach(btn => btn.remove());

  const thumbVw = document.querySelector('.thumb');
  const imgvw = thumbVw?.querySelector('img');

  if (thumbVw && imgvw) {
    const prevImg = thumbVw.previousElementSibling;
    imgvw.alt = '';
    if (!prevImg || prevImg.tagName !== 'IMG') {
      const imgClone = imgvw.cloneNode(true);
      thumbVw.parentNode.insertBefore(imgClone, thumbVw);
    } 
  }

   const swatch = document.querySelector('.js-swatch_wrapper.current');
    if (swatch) {
      const images = swatch.dataset.imagesThumb?.split(';') || [];

      document.querySelectorAll('.js-desktop-images-wrapper img:not(.zoomImg)').forEach((imgEl, index) => {
        const imageSrc = images[index];
        if (imageSrc && imageSrc.includes('reeview')) {
            const widgetId = extractWidgetId(imageSrc);
            imgEl.alt = widgetId || '';
            const lastSegment = widgetId.split('-').pop();
            if (typeof window.__st.rid !== 'undefined') {
              window.__st.rid = lastSegment;
            }
        } 
      });
    }

  if (typeof videowiseBulkTrigger === 'function' && typeof initVideowise === 'function') {
    try {
       setTimeout(() => {
      videowiseBulkTrigger();
      initVideowise();
       }, 300);
    } catch (err) {
      console.error('❌ Error calling Videowise functions:', err);
    }
  }
}, 300);

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.js-swatch_wrapper');
  if (!swatch) return;
  const img = document.querySelector('.js-desktop-image-item');
  if (!img) {
    return;
  }

  setTimeout(() => {
    handleSrcChange(img);
  }, 300); 
});
